import * as React from 'react';
import type { SVGProps } from 'react';

interface SvgMenuTmsProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const SvgMenuGlobe = ({ fillColor = '#616061', ...props }: SvgMenuTmsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} >
    <path fillRule="evenodd" clipRule="evenodd"
          d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.90693 12.0391C2.1725 11.1142 1.68466 9.98473 1.5428 8.75H14.4572C14.3153 9.98473 13.8275 11.1142 13.0931 12.0391C11.7451 11.465 10.0274 11 7.99998 11C5.97261 11 4.25488 11.465 2.90693 12.0391ZM4.0826 13.1874C5.17193 14.0113 6.52889 14.5 8 14.5C9.4711 14.5 10.8281 14.0113 11.9174 13.1874C10.8267 12.7916 9.51065 12.5 7.99998 12.5C6.48933 12.5 5.17329 12.7916 4.0826 13.1874ZM2.90692 3.96096C2.1725 4.8858 1.68466 6.01528 1.5428 7.25H14.4572C14.3153 6.01527 13.8275 4.88579 13.0931 3.96095C11.7451 4.53504 10.0274 5.00001 7.99998 5.00001C5.97261 5.00001 4.25487 4.53505 2.90692 3.96096ZM4.08259 2.81264C5.17329 3.20843 6.48932 3.50001 7.99998 3.50001C9.51066 3.50001 10.8267 3.20843 11.9174 2.81264C10.8281 1.98871 9.47111 1.5 8 1.5C6.52889 1.5 5.17192 1.98871 4.08259 2.81264Z"
          fill={fillColor}/>

  </svg>
);
export default SvgMenuGlobe;
